import './styles.scss'
import React, { useState } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Nav, NavbarBrand, Button } from 'reactstrap'

import settingsActions from 'redux/settings/actions'
import HeaderDropdown from './HeaderDropdown'
import FlowErrors from '../ModulePlanActivation'
import HeaderNotice from './HeaderNotice'
import dkvConfiguration from 'constants/dkv.constants'
import { getStaticImage } from 'utils/statics'
import NotificationDash from './NotificationDash'
import SearchEngine from 'components/SearchEngine'
import flagEnvDisplay from 'constants/flagEnvDisplay'

const Header = (props) => {
  const { operator, company, settings, dispatch } = props
  const hash = window.location.hash
  const [headerNotice, setHeaderNotice] = useState(false)

  const companyName = company?.nameToDisplay || company?.name || ''

  const refreshPage = () => window.location.reload()

  return (
    <header className={`app-header navbar ${headerNotice && 'notice-warning'} ${hash !== '#/' ? 'navBarShadow' : ''}`}>
      {operator.authToken && operator.role !== 'user' ? (
        <button
          type='button'
          className='app-header__navbar'
          onClick={() => dispatch(settingsActions.set({ isMainMenuOpen: !settings.isMainMenuOpen }))}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-menu-dark.svg')} alt='Navbar' />
          </figure>
        </button>
      ) : null}

      <NavbarBrand href='#/' className={headerNotice ? 'notice-warning' : ''} />

      {(operator.authToken && flagEnvDisplay.displayGlobalSearch) ? <SearchEngine /> : null}

      <HeaderNotice
        onChange={(data) => setHeaderNotice(data)}
      />

      <FlowErrors />
      {operator.authToken ? (
        <Nav className='ml-auto mr-4' navbar>
          {companyName && (
            <li className='nav-item'>
              <div className='company-name'>{companyName}</div>
            </li>
          )}
          <NotificationDash />
          <HeaderDropdown />
        </Nav>
      ) : (
        <Nav className='ml-auto mr-4' navbar>
          {dkvConfiguration.loginWithOpenId ? (
            <Button color='link' className='loginButton' onClick={refreshPage}>
              {I18n.t('button_login')}
            </Button>
          ) : (
            <Link to='/login'>{I18n.t('button_login')}</Link>
          )}
        </Nav>
      )}
    </header>
  )
}

function mapStateToProps(state) {
  return {
    operator: state.user,
    company: state.companies,
    brands: state.brands,
    settings: state.settings
  }
}

export default connect(mapStateToProps)(withRouter(Header))
